export default "__VITE_ASSET__lISclY8I__"